function VenuePageHeaderDirective() {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    scope: {
      pageTitle: '=',
      venues: '=',
      venue: '=',
      onSelected: '='
    },
    template: `
<div class="new-page-header venue-page-header clearfix">
  <div class="pull-left clearfix">
    <h1 class="main-header pull-left">
      {{ pageTitle }}
    </h1>
    <div class="venue-selector pull-left">
      <div class="dropdown">
        <button class="venue-selector-btn btn btn-default dropdown-toggle" type="button" data-toggle="dropdown">
          {{ venue.name }}
          <i class="ion-ios-arrow-down"></i>
        </button>
        <ul class="dropdown-menu dropdown-menu-with-arrows pull-left">
          <li ng-repeat="venue in venues">
            <a href="#" ng-click="changeVenue(venue, $event)">
              {{ venue.name }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <ng-transclude></ng-transclude>
</div>
  `,
    link: (scope) => {
      scope.currentVenue = scope.venue || (scope.veneus ? scope.venues[0] : null);

      scope.changeVenue = function (venue, $event) {
        if ($event) $event.preventDefault();

        scope.currentVenue = venue;

        if (scope.onSelected) scope.onSelected(scope.currentVenue);
      };
    }
  };
}

VenuePageHeaderDirective.$inject = [];

export default VenuePageHeaderDirective;



// WEBPACK FOOTER //
// ./src/directives/venuePageHeader.js